import React from 'react';
import { IonButton, IonIcon } from '@ionic/react';
import { logoGoogle } from 'ionicons/icons';
import { useUser } from '../../contexts/UserContext';

const GoogleLoginButton: React.FC = () => {
  const { loginWithGoogle } = useUser();

  return (
    <IonButton onClick={loginWithGoogle} expand="block">
      <IonIcon icon={logoGoogle} slot="start" />
      Login with Google
    </IonButton>
  );
};

export default GoogleLoginButton;
